module.exports = __webpack_public_path__ + "media/images/icons/connect-icon-49be2b98c02207a8921b943612fe0268.svg";